module.exports = __webpack_public_path__ + "media/samurai_in_the_bamboo.6c6e7134.ogg";